export default __webpack_public_path__ + "static/media/LiquidOil_Pipe.256.edd44fa5.png";